<div class="er-dialog">

  <!-- Header -->
  <div class="er-header">
    <div class="er-title-wrap">
      <div class="er-title-icon">
        <mat-icon>autorenew</mat-icon>
      </div>
      <div class="er-title-text">
        <h2 class="er-title">Repeat</h2>
        <div class="er-subtitle">Set a recurrence for this event</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="er-close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form id="repeat" class="er-body" (ngSubmit)="submit()">

    <div class="er-field">
      <label class="er-label">Repeat every</label>
      <div class="er-every-row">
        <input class="er-number" type="number" min="1" [(ngModel)]="number" name="number">
        <div class="er-seg">
          <button type="button" [class.on]="interval === 'daily'" (click)="interval = 'daily'; intervalChange('daily')">Days</button>
          <button type="button" [class.on]="interval === 'weekly'" (click)="interval = 'weekly'; intervalChange('weekly')">Weeks</button>
          <button type="button" [class.on]="interval === 'monthly'" (click)="interval = 'monthly'; intervalChange('monthly')">Months</button>
        </div>
      </div>
    </div>

    @if (interval == 'weekly') {
      <div class="er-field">
        <label class="er-label">On these days</label>
        <div class="er-days">
          @for (day of weekDays; track day.value) {
            <button type="button" class="er-day" [class.on]="daysOfWeek.includes(day.value)"
              (click)="toggleDay(day.value)" [attr.aria-pressed]="daysOfWeek.includes(day.value)">
              {{day.label}}
            </button>
          }
        </div>
      </div>
    }

    <div class="er-field er-field-last">
      <label class="er-label">Ends on</label>
      <div class="er-picker">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="endDatePicker" placeholder="Choose an end date" name="endDate" [formControl]="endDate" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Footer -->
  <div class="er-footer">
    <button mat-button mat-dialog-close class="er-btn-ghost">Cancel</button>
    <button type="submit" form="repeat" class="er-btn-primary">
      <span>Apply</span>
      <mat-icon>check</mat-icon>
    </button>
  </div>
</div>
